<template>
  <v-card>
    <v-toolbar color="grey lighten-3" height="40">
      <v-toolbar-title :class="titlePadding">Custom Editor Help</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <div :class="listPadding" v-html="helpText"></div>
    </v-card-text>
  </v-card>
</template>
<script>
import axios from 'axios'
import SidebarPropsMixin from './SidebarPropsMixin'
const { marked } = require('marked')

export default {
  name: 'editor-help-sidebar',
  mixins: [SidebarPropsMixin],
  props: {
    helpUrl: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      help: ''
    }
  },
  watch: {
    helpUrl: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal) {
          axios.get(newVal)
            .then(resp => {
              this.help = resp.data
            })
        }
      }
    }
  },
  computed: {
    helpText () {
      if (this.help) {
        return marked.parse(this.help)
      } else {
        return ''
      }
    }
  }
}
</script>
